import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HighQualityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"high_quality"}/>
}
